/**
 * The connection and the exact target of a SAS, shown before Generate (UI/UX fix round A, reviews A1 / U19). For an
 * account SAS it says that the token covers the whole account in the ticked services and which resource types it grants.
 */
import type { StorageResourceRef } from '../../../../../../types/azureStorage';
import { useConnectionStore } from '../../../../../connections/store/connectionStore';
import { ACCOUNT_SAS_RESOURCE_TYPES, accountSasScope, sasTargetLabel } from './sasTargetLabel';
import { safeConnectionName } from '../../../../../../types/safeConnectionDisplay';

export function SasTargetSummary({ connectionId, target, openedFrom }: { connectionId: string; target: StorageResourceRef; openedFrom: StorageResourceRef }) {
  const connection = useConnectionStore((state) => state.connections.find((candidate) => candidate.id === connectionId));
  const name = safeConnectionName(connection, connectionId);
  return (
    <div className="space-y-0.5 rounded-md border border-border bg-muted/40 px-3 py-2 text-xs" data-testid="storage-sas-target">
      <div><span className="text-muted-foreground">Connection:</span> <span className="break-words text-foreground">{name}</span></div>
      <div><span className="text-muted-foreground">Signed for:</span> <span className="break-words font-medium text-foreground" data-testid="storage-sas-target-label">{sasTargetLabel(target)}</span></div>
      {target.kind === 'account' && <>
        <div className="text-foreground" data-testid="storage-sas-account-scope">{accountSasScope(openedFrom)}</div>
        <div className="text-muted-foreground">{ACCOUNT_SAS_RESOURCE_TYPES}</div>
      </>}
    </div>
  );
}
